module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "intro_hd",
      "role": "doc-introduction"
    }
  }, [_c('div', {
    staticClass: "ash1"
  }, [_c('h1', {
    staticClass: "h1",
    attrs: {
      "id": "intro_hd"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page 4",
      "id": "page_4",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page 5",
      "id": "page_5",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page 6",
      "id": "page_6",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page 7",
      "id": "page_7",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Introduction")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Hello, and welcome to "), _c('i', [_vm._v("Teach Your Dog to Talk")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you’re reading these words, you obviously want to learn how to communicate with your dog or any other species of pets (cat/lizard/horse/peacock/lemur/pig) that are currently students/learners of animal Augmentative and Alternative Communication (AAC). Even though this book is called "), _c('i', [_vm._v("Teach Your Dog to Talk")]), _vm._v(", rest assured that I see you exotic animal teachers and think it’s super cool that you have a “talking” iguana. Learners can be furry, scaled, or feathered, but the basics of animal AAC are essentially the same. The only difference is that you may have to modify your approach based on your learner’s size or species.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 8",
      "id": "page_8",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Animal AAC is a relatively new phenomenon pioneered by speech-language pathologist Christina Hunger. Ms. Hunger had the bright idea of creating the first word board for her dog, Stella, a Catahoula/Australian cattle dog mix. She has also written a book called "), _c('i', [_vm._v("How Stella Learned to Talk,")]), _vm._v(" which is part memoir and part how-to guide. For anyone wanting to do a deep dive into the world of AAC, I recommend picking up Ms. Hunger’s book, in which her experience and background shine.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Teach Your Dog to Talk")]), _vm._v(" focuses on some best practices being employed by learners and their teachers (pet owners) "), _c('i', [_vm._v("to date")]), _vm._v(". This is to say that animal AAC is an evolving landscape. Just as with dog training, many people within the animal-training community and beyond will probably begin to develop their own opinions about and methodologies for achieving the same end goal—getting your pet to communicate effectively. Since I belong to numerous groups devoted to learning more about animal AAC, I am distilling our shared experiences into what I hope will be an informative and easy-to-follow guide for teaching your dog to talk. I am by no means an animal behavior or AAC expert, but I am an enthusiastic supporter of this "), _c('span', {
    attrs: {
      "aria-label": "page 9",
      "id": "page_9",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("movement and want to help you get started as quickly and as easily as possible.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The community of learners and teachers of animal AAC has mushroomed ever since Ms. Hunger posted an Instagram video of Stella “talking” using the Learning Resources Recordable Answer Buzzers back in October 2019. And, while those of us participating in this exciting endeavor still wonder to what extent the animals understand language, we have enough anecdotal evidence to suggest that our learners are at least communicating with us effectively.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "lev01"
    }
  }, [_vm._v("My Talking Dog")]), _vm._v(" "), _c('p', {
    staticClass: "noindenti"
  }, [_vm._v("I began teaching my dog, Casper, to use the recordable buttons in 2019, shortly after seeing Stella’s videos on Instagram. Casper is a Border Aussie (50 percent border collie and 50 percent Australian shepherd). Besides his being adorable, one of the reasons I chose him was because both border collies and Australian shepherds have a fantastic working memory for language. This makes them highly trainable and, as I would come to find out, great candidates for AAC learning.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 10",
      "id": "page_10",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Soon after purchasing my first set of recordable buttons, I turned our dining room into a makeshift Dog Button Board Craft Workshop, much to my family’s dismay. I’m pretty sure they thought I was crazy, and given that I also have a penchant for grand projects that often go unfinished, they were no doubt rolling their eyes at my latest “hobby.” But there I was with some plywood, recordable buttons, and Velcro, determined to get my dog talking.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("While “talking” with your dog has a very real utilitarian purpose, I have remained committed to this project because it is engaging and, oftentimes, hilarious. Casper became an accidental TikTok sensation when I posted a video of him getting mad at my daughter for not taking him on a golf cart ride. We’ve enjoyed all the support we’ve gotten online. There are still a lot of skeptics, and that’s okay. Sometimes "), _c('i', [_vm._v("we")]), _vm._v(" don’t even believe that Casper’s communication skills are real.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "lev02"
    }
  }, [_vm._v("Why I Wrote This Book")]), _vm._v(" "), _c('p', {
    staticClass: "noindenti"
  }, [_vm._v("I wrote this how-to book for a couple of reasons. First, I’m the parent of an autistic child, and even though "), _c('span', {
    attrs: {
      "aria-label": "page 11",
      "id": "page_11",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("he is verbal now, years of speech therapy brought him to where he is today. His speech therapists used various forms of AAC with him, so I saw firsthand how beneficial it was and still is. That’s why, when I saw Stella using her words for the first time, I thought, “Well, of "), _c('i', [_vm._v("course")]), _vm._v(" they can communicate!” It really resonated with me for that reason.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In "), _c('i', [_vm._v("How Stella Learned to Talk")]), _vm._v(", Ms. Hunger laments the fact that more speech-language pathologists aren’t trained to use AAC."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781646042760/xhtml/intro#footnote-005",
      "id": "footnote-005-backlink"
    }
  }, [_vm._v("1")])]), _vm._v(" Hopefully, books like hers, this one, future ones, and this entire movement will bring more awareness to AAC in general. AAC tools are remarkable in that they help unlock the power of communication for those individuals who don’t have the capacity for language, be they humans or animals. We’re getting a window into our learners’ minds, which were previously inaccessible to us because we didn’t realize they could use these tools.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Giving our animal companions some power over their communication skills is really incredible. The fact is, we are seeing animals convey emotions that we wouldn’t otherwise understand if they didn’t have these "), _c('span', {
    attrs: {
      "aria-label": "page 12",
      "id": "page_12",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("devices. Casper can tell us when he’s “mad” or “sad.” It never gets old seeing a learner make progress and communicate something fairly complex.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I talk to Casper and our new puppy Chico’s vets all the time about the animal AAC movement, which they wholeheartedly support. However, they said most vet schools don’t cover much about animal emotions. One person who has interesting insight into communication is Temple Grandin, whom I learned about due to my son’s autism diagnosis. She is an animal behavior expert who also happens to have autism. In a speech given to vet students at Tufts University, she said evidence is clear that animals experience fear, rage, panic, novelty seeking, and other emotions such as lust, caring, and playfulness."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781646042760/xhtml/intro#footnote-004",
      "id": "footnote-004-backlink"
    }
  }, [_vm._v("2")])]), _vm._v(" This isn’t a surprise to most pet owners, especially those of us utilizing AAC. We see our pets use words to communicate emotions on a regular basis.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It will be interesting to see what impact this movement will have on the field of veterinary medicine, animal "), _c('span', {
    attrs: {
      "aria-label": "page 13",
      "id": "page_13",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("behavior, and cognitive science. Given the volume of learners who are being followed by researchers at the University of California San Diego in a study run by the Comparative Cognition Lab, I can only imagine what this data will mean for them. Previously, they might have encountered one or two remarkable cases. With well over one thousand learners (and growing!) being tracked, I expect they will be able to publish some very intriguing findings.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The second reason I chose to write this is because I feel like the more information we all contribute to the collective understanding of animal AAC, the better. We are having a great time, and I think our learners are enjoying themselves as well. Because of that, I think we owe it to the movement at large to contribute as much as we can to the “hive mind” understanding of best practices and evolving technology. Most of us aren’t trained professionals in cognitive science, speech pathology, or animal behavior, but as evangelists for animal AAC, we can definitely help spread the word and help others unlock the communication potential in their learners.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 14",
      "id": "page_14",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("People ask me all the time for tips on how to get started. I’ve even been asked to work as a paid tutor or consultant to help people build their boards and begin working with their learner. I have no doubt an entire cottage industry will spring up around this movement. While I don’t have any intention of doing this as a job, I do feel like helping people get started with this activity is a great thing to pay forward. Hopefully, this book will help in that regard.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I’ve always taught my dogs tricks like rolling over, crawling, or sitting up. That’s something fun to do with any pet. Animal AAC is a wonderful activity that has practical implications. I’m getting to know my dogs’ personalities on a much deeper level because they can now communicate their emotions to me. Many animal AAC enthusiasts have commented that their learners seem less anxious, whiny, and barky now that they can more clearly communicate their wants and needs.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "lev03"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page 15",
      "id": "page_15",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("What You Can Expect from This Book")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenti"
  }, [_vm._v("You might discover that you have a very demanding animal once they learn to use their newfound skills. In addition to prepping you with a basic review of animal AAC and talking animals, this book will teach you how to navigate the tools of the trade, narrate your activities, and practice patience throughout the process.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Later in the book, we’ll cover common vocabulary words to teach your pet, including why it isn’t a good idea to introduce “food” or “treat” right away. This brings up a good point: don’t teach your animal to use these buttons if you’re not prepared to have a furry creature commanding you to attend to their every need like a tiny dictator. I love my tiny dictator, but thank goodness we have a “no” button.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Finally, we’ll go over monitoring progress through what I hope will become an ongoing journey of communication and discovery. I’ll provide resources and encouragement for success in the long run. Let’s not forget the biggest motivation for exploring this possibility with your pet—to have fun!")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781646042760/xhtml/intro#footnote-005-backlink",
      "id": "footnote-005"
    }
  }, [_vm._v("1")]), _vm._v(" Christina Hunger, "), _c('i', [_vm._v("How Stella Learned to Talk")]), _vm._v(" (New York: HarperCollins, 2021).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781646042760/xhtml/intro#footnote-004-backlink",
      "id": "footnote-004"
    }
  }, [_vm._v("2")]), _vm._v(" Susan Spencer, “Animal Behavior Expert Temple Grandin Tells Veterinary Students That Understanding Animals’ Emotions Is Key,” "), _c('a', {
    attrs: {
      "href": "http://Telegram.com",
      "target": "_blank"
    }
  }, [_vm._v("Telegram.com")]), _vm._v(", December 2, 2015, "), _c('a', {
    attrs: {
      "href": "https://www.telegram.com/article/20151201/NEWS/151209921/101371",
      "target": "_blank"
    }
  }, [_vm._v("https://www.telegram.com/article/20151201/NEWS/151209921/101371")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bca4d4f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781646042760/xhtml/intro.vue
// module id = 66
// module chunks = 0